import React from "react";
import SchoolTimingsLayer from "../components/school/SchoolTimingsLayer";
import MasterLayout from "../masterLayout/MasterLayout";

function SchoolTimingsPage() {
  return (
    <MasterLayout>
        <SchoolTimingsLayer />
    </MasterLayout>
  )
}

export default SchoolTimingsPage;
